import React from 'react';
import { Svg } from 'components/icons/Svg';

export const IconPlus = props => (
  <Svg {...props}>
    <path d="M13 6a1 1 0 00-2 0h2zm-2 12a1 1 0 102 0h-2zm0-12v12h2V6h-2z" fill="currentColor" />
    <path d="M6 11a1 1 0 100 2v-2zm12 2a1 1 0 000-2v2zM6 13h12v-2H6v2z" fill="currentColor" />
  </Svg>
);
